import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TagManager from 'react-gtm-module';

class GoogleTagManager extends Component {
  constructor(props) {
    super(props);
    TagManager.initialize({
      gtmId: this.props.config.id,
    });
  }

  render() {
    return null;
  }
}

GoogleTagManager.propTypes = {
  config: PropTypes.object.isRequired,
};

export default GoogleTagManager;
